/**
 * The secret a returning player proves its seat with.
 *
 * A peer id cannot do this job: the network mints a fresh one every time a connection is made, so
 * the player who comes back is, as far as the room is concerned, a stranger. The token is the thing
 * that stays the same, which makes it the identity.
 *
 * It is random rather than derived, because anything derived from a player number is a number
 * anybody in the room could work out, and taking somebody's seat while they are trying to get back
 * into it is the one thing this has to prevent. Eight bytes is far more than enough for a guess to
 * be hopeless inside a fifteen second window.
 *
 * Hex, so it compares and logs as a plain string. The wire spends the eight bytes.
 */

import { LOBBY_TOKEN_BYTES } from '@/net/wire/lobbyFrame';

export function mintRejoinToken(): string {
  return [...crypto.getRandomValues(new Uint8Array(LOBBY_TOKEN_BYTES))]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}
